module.exports = __webpack_public_path__ + "img/card_img_2.f69cdfa9.png";